<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<template>
  <section
    :class="['area_search', { isShow: scrollDirection.isScrollDown && !menuData.isMobileOpen }]"
  >
    <h3 class="screen_out">{{ props.title }}검색하기</h3>
    <div class="head_search">
      <div>
        <SelectCate
          :optList="sortData"
          :styleType="'selectTop'"
          @selectItem="sortSelectItem"
        />
      </div>
    </div>
  </section>
</template>
<script setup>
import { useScrollDirection, useDimmedOpen, useMenuData } from '/stores/store';
import { useBusinessServices } from '/composables/business';

const scrollDirection = useScrollDirection();
const dimmedOpen = useDimmedOpen();
const menuData = useMenuData();
const emit = defineEmits(['doSearch']);
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
  searchData: {
    type: Object,
    default() {
      return {};
    },
  },
});
const listNewsCate = ref([
  {
    name: '전체',
    isSelected: true,
    data: '',
  },
  {
    name: '언론보도',
    isSelected: false,
    data: 'REPORT',
  },
  {
    name: '인사이트',
    isSelected: false,
    data: 'INSIGHT',
  },
  {
    name: '알립니다',
    isSelected: false,
    data: 'NOTICE',
  },
]);
const { business: listBusiness } = await useBusinessServices();

const listCategory = ref([
  {
    name: '전체',
    isSelected: true,
    data: '',
  },
  {
    name: '서비스',
    isSelected: false,
    data: 'service',
  },
  {
    name: '고객사례',
    isSelected: false,
    data: 'partner',
  },
  {
    name: '뉴스',
    isSelected: false,
    data: 'news',
  },
  {
    name: '자료실',
    isSelected: false,
    data: 'information',
  },
]);

const sortData = computed(() => {
  switch (props.type) {
    case 'result':
      return listCategory.value; //검색
    case 'news':
      return listNewsCate.value; //뉴스
    case 'case':
      return setExcludedList(listBusiness.value, '디케이테크인'); //고객사례 - 제외 요청으로 fe에서 별도처리
    default:
      return listBusiness.value; //자료실
  }
});

const compSearchData = ref({
  //검색시 보낼 영역
  dataNewsCate: {},
  dataSort: {},
});

const doSearch = () => {
  emit('doSearch');
  window.scrollTo(0, 0);
  dimmedOpen.toggleDimmed('close');
};

// 셀렉트 동작
const selectItem = (index, list, dataKey) => {
  list.value.forEach((ele, idx) => {
    if (index !== idx) {
      ele.isSelected = false;
    } else {
      ele.isSelected = true;
      compSearchData.value[dataKey] = ele;
      doSearch();
    }
  });
};

const sortSelectItem = (index) => {
  selectItem(index, sortData, 'dataSort');
};

const sortSelectNewsItem = (index) => {
  selectItem(index, listNewsCate, 'dataNewsCate');
};

onMounted(() => {
  //처음값 세팅
  compSearchData.value = props.searchData;
});
</script>
<style lang="scss" scoped>
.area_search {
  display: none;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 40px;
  z-index: 10000;
  background-color: #fff;
  &.isShow {
    display: block;
  }
}
.head_search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  .btn_open {
    @include setSize(24px, 24px);
    @include searchLensIcon();
    background-size: 24px 24px;
    &.type_close {
      @include closeBtnIcon();
    }
  }
}
.body_search {
  padding-bottom: 24px;
}
@media screen and (max-width: 811px) {
  .area_search {
    padding: 0 20px;
  }
  .head_search {
    height: 60px;
  }
  .body_search {
    padding-bottom: 16px;
  }
}
</style>
